import React, { useContext, useEffect } from 'react'
import { EventList } from './EventList'
import { EventShortList } from './EventShortList'
import { AppContext } from '../context/AppContext'
import Axios from 'axios'

export const EventSection = ({ list, count, isShort }) => {
  const { appState, appDispatch } = useContext(AppContext)

  useEffect(() => {
    window.ASC_EVENT_LOADER.filter(({ id }) => {
      return !list || id.toLowerCase() === list
    }).forEach(({ id, url }) => {
      Axios.get(url).then(({ data }) => {
        appDispatch({
          type: 'ADD_EVENTS',
          id,
          events: data.events,
          categories: data.categories,
          locations: data.locations || [],
        })
      })
    })
  }, [appDispatch, list])

  return (
    <div>
      {isShort ? (
        appState.eventLists.map((list) => {
          return (
            <EventShortList
              list={list}
              key={list.id}
              count={count}
              className={`asc-event-list asc-event-list-${list.id} event-list-${list.id}`}
            />
          )
        })
      ) : (
        <>
          {appState.eventLists.map((list) => {
            return (
              <EventList
                list={list}
                key={list.id}
                className={`asc-event-list asc-event-list-${list.id}`}
              />
            )
          })}
        </>
      )}
    </div>
  )
}
